import { ChevronLeft } from 'lucide-preact';
import { route } from 'preact-router';

interface PageHeaderProps {
  title: string;
  /** Where to go when there is no in-app history to pop back to. */
  fallback: string;
}

/** Screen header with a back control. Uses natural history when possible,
 * otherwise routes to a sensible fallback so back never lands on a blank
 * page (051 FR-007). */
export function PageHeader({ title, fallback }: PageHeaderProps) {
  function goBack() {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      route(fallback);
    }
  }

  return (
    <div className="flex items-center gap-3 mb-4">
      <button
        type="button"
        aria-label="Back"
        onClick={goBack}
        className="flex items-center gap-1 text-gray-400 hover:text-text transition-colors"
      >
        <ChevronLeft size={20} aria-hidden="true" />
      </button>
      <h1 className="text-xl font-bold text-text">{title}</h1>
    </div>
  );
}
